import { PUT_ABOUT_US_ERROR, PUT_ABOUT_US_START, PUT_ABOUT_US_SUCCESS } from '../../types';

export default function put_about_us(state, action) {
  switch (action.type) {
    case PUT_ABOUT_US_START:
      return { ...state };
    case PUT_ABOUT_US_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_ABOUT_US_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
